import { mapControl } from '@/constants';
const { orderStatusGroupList } = mapControl;
const orderTotal = {
    [orderStatusGroupList.ALL.code]: 0,
    [orderStatusGroupList.ACCEPTED.code]: 0,
    [orderStatusGroupList.ALLOCATED.code]: 0,
    [orderStatusGroupList.PICKUP.code]: 0,
};
const workerTotal = {
    all: 0,
    waiting: 0,
    driving: 0,
    rest: 0,
};
const state = {
    /** 관리자CS를 타고 온 본사 여부. 본사일 경우 본사 계정이 입력 된다. ADMIN_XXX */
    isHQ: '',
    searchOrderQuery: '',
    searchWorkerQuery: '',
    isOpenModalAllocate: 0,
    isOpenConfigDialog: false,
    // 설정 다이얼로그
    mapVisibilitySetting: {
        // 공유건 숨김 (리스트, 마커)
        isHideShareOrder: false,
        isHideShareWorker: false,
        // 마커 숨김
        isHideStoreMarker: false,
        isHideWorkerMarker: false,
    },
    modalOrderData: {},
    modalWorkerData: {},
    // 선택한 라이더
    selectedWorker: null,
    selectedStoreId: null,
    selectedStoreOrderList: {},
    selectedWorkerOrderList: {},
    selectedOrderItemsObj: {},
    selectedOrderFilter: [],
    selectedWorkerFilter: [],
    workerList: {},
    orderList: {},
    storeList: {},
    relatedWorkerList: {},
    orderTotal,
    workerTotal,
    mapHoveredOrderId: '',
    /* eslint-disable object-curly-newline */
    selectedBySnackbar: {
    // 임시 Interface..!!
    // storeName: ''
    // orderId: '',
    // title: '',
    // workerName: ''
    },
    // 선택한 스낵바 index
    selectedItemKey: -1,
};
export default state;
